module.exports = __webpack_public_path__ + "img/AEON-alt.392e7372.svg";